import { apiV1 } from '~/services/api';
import { type WebhookAPIType } from '~/types/Webhooks';

const editWebhook = (data: WebhookAPIType) =>
  apiV1.request({
    data: {
      active: data.active,
      event: data.event,
      is_test: data.is_test,
      url: data.url,
    },
    method: 'PUT',
    url: `/webhooks/${data.object_id}`,
  });

const deleteWebhook = (data: WebhookAPIType) =>
  apiV1.request({
    method: 'DELETE',
    url: `/webhooks/${data.object_id}`,
  });

const saveWebhook = (data: WebhookAPIType) =>
  apiV1.request({
    data: {
      active: data.active,
      event: data.event,
      is_test: data.is_test,
      url: data.url,
    },
    method: 'POST',
    url: `/webhooks/`,
  });

const testWebhook = (data: WebhookAPIType) =>
  apiV1.request({
    data: {
      event: data.event === '*' ? 'track_updated' : data.event,
    },
    method: 'POST',
    url: `/webhooks/${data.object_id}/test`,
  });

const getWebhooks = () =>
  apiV1.request({
    url: '/webhooks',
  });

export { deleteWebhook, editWebhook, getWebhooks, saveWebhook, testWebhook };
